<template>
  <v-dialog v-model="showLocal" persistent max-width="520">
    <v-card tile flat>
      <v-card-title class="headline">Kiállítás vége</v-card-title>
      <v-card-text>
        <v-card tile flat>
          <v-card tile flat v-if="restoreList.A && restoreList.B">
            {{restoreText}}
            <br><br>
            <v-card flat tile class="d-flex" :class="isMirrored ? 'flex-row-reverse': ''">
              <v-card flat tile width="50%" :class="isMirrored ? 'pl-2': 'pr-2'">
                <span class="exclude-team">{{gamedata[!isMirrored ? 'team_a_name' : 'team_b_name']}} csapat</span>
                <br><br>
                <v-card flat tile v-for="i in restoreList.A" :key="'1A_'+i">
                  <v-card tile flat>{{getLabel('A', i-1)}}:</v-card>
                  <v-select v-model="dialogData.teams['A'][i-1].selected"
                            class="width-100"
                            :items="playersStatus['passive']['A']"
                            item-value="id"
                            :item-text="(player) => player.jersey + ' ' + player.name"
                            label="Játékos"
                  />
                </v-card>
              </v-card>

              <v-card flat tile width="50%" :class="isMirrored ? 'pr-2': 'pl-2'">
                <span class="exclude-team">{{gamedata[!isMirrored ? 'team_b_name' : 'team_a_name']}} csapat</span>
                <br><br>
                <v-card flat tile v-for="i in restoreList.B" :key="'1B_'+i">
                  <v-card tile flat>{{getLabel('B', i-1)}}:</v-card>
                  <v-select v-model="dialogData.teams['B'][i-1].selected"
                            class="width-100"
                            :items="playersStatus['passive']['B']"
                            item-value="id"
                            :item-text="(player) => player.jersey + ' ' + player.name"
                            label="Játékos"
                  />
                </v-card>
              </v-card>
            </v-card>
          </v-card>

          <v-card tile flat v-if="restoreList.A && !restoreList.B">
            {{restoreText}}
            <br><br>
            <span class="exclude-team">{{gamedata['team_a_name']}} csapat</span>
            <br><br>
            <v-card flat tile v-for="i in restoreList.A" :key="'2A_'+i" width="100%">
              <v-card tile flat>{{getLabel('A', i-1)}}:</v-card>
              <v-select v-model="dialogData.teams['A'][i-1].selected"
                        class="width-100"
                        :items="playersStatus['passive']['A']"
                        item-value="id"
                        :item-text="(player) => player.jersey + ' ' + player.name"
                        label="Játékos"
              />
            </v-card>
          </v-card>

          <v-card tile flat v-if="!restoreList.A && restoreList.B">
            {{restoreText}}
            <br><br>
            <span class="exclude-team">{{gamedata['team_b_name']}} csapat</span>
            <br><br>
            <v-card flat tile v-for="i in restoreList.B" :key="'2B_'+i" width="100%">
              <v-card tile flat>{{getLabel('B', i-1)}}:</v-card>
              <v-select v-model="dialogData.teams['B'][i-1].selected"
                        class="width-100"
                        :items="playersStatus['passive']['B']"
                        item-value="id"
                        :item-text="(player) => player.jersey + ' ' + player.name"
                        label="Játékos"
              />
            </v-card>
          </v-card>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn depressed tile v-if="dialogData.UUID" @click="cancel">Mégsem</v-btn>
        <v-btn depressed tile color="green" :disabled="isDisabled" @click="save">Mentés</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from "@/eventBus";
import CONSTANTS from "@/constants";

export default {
  name: 'RestoreDialog',
  props: {
    value: Boolean, // v-model a láthatósághoz
    dialogData: Object, // A restoreDialog objektum
    gamedata: Object,
    isMirrored: Boolean,
    playersStatus: Object
  },
  computed: {
    showLocal: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    },
    restoreList() {
      return {
        A: this.dialogData.teams['A'] ? this.dialogData.teams['A'].length : 0,
        B: this.dialogData.teams['B'] ? this.dialogData.teams['B'].length : 0
      };
    },
    restoreText() {
      return (this.restoreList.A + this.restoreList.B) > 1
          ? 'Válassza ki melyik játékosok menjenek fel a pályára!'
          : 'Válassza ki melyik játékos menjen fel a pályára!';
    },
    isDisabled() {
      let rtn = false;
      ['A', 'B'].forEach(team => {
        if (this.dialogData.teams[team]) {
          this.dialogData.teams[team].forEach(item => {
            if (!item.selected) rtn = true;
          });
        }
      });
      return rtn;
    }
  },
  methods: {
    save() {
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
      this.$emit('save');
    },
    cancel() {
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
      this.$emit('cancel');
    },
    getLabel(team, index) {
      const item = this.dialogData.teams[team][index];
      return item.excluded
          ? this.getExcludedName(item.excluded, team) + ' helyére'
          : 'Hivatalos személy kiállítása lejárt';
    },
    getExcludedName(player, team) {
      let playerId = player.id ? player.id : player;
      let teamText = this.teamConvert(team);
      let obj = this.getPlayer(playerId, teamText);
      return obj ? (obj.jersey + ' ' + obj.name) : '';
    },
    teamConvert(team) {
      return (team === "A") ? 'team_a_players' : 'team_b_players';
    },
    getPlayer(id, team) {
      if (!this.gamedata[team]) return null;
      return this.gamedata[team].find(item => item.id === id);
    }
  }
}
</script>

<style scoped>
.exclude-team {
  font-size: 18px;
  font-weight: bold;
}
</style>
